import axios from '@/utils/request'


// 获取用户列表
export const getMemberList = (params)=>{
  return axios.request({
     url: 'v1/member/index',
     method: 'get',
     params
   }) 
 };
// 获取用户详情
export const getMemberDetail = (id)=>{
  return axios.request({
     url: 'v1/member/'+id,
     method: 'get'
   })
};
// 会员加标签
export const tagMember= (data)=>{
  return axios.request({
    url: 'v1/member/'+data.user_id+'/tag',
    method: 'post',
    data
  })
};
// 会员删标签
export const tagMemberDel= (data)=>{
  return axios.request({
    url: 'v1/member/delMemberTag',
    method: 'post',
    data
  })
};
// 会员加入黑名单
export const addUserBack= (id)=>{
  return axios.request({
    url: 'v1/member/black/'+id,
    method: 'post'
  })
};

// 会员编辑备注
export const editUserRemark= (data)=>{
  return axios.request({
    url: 'v1/member/updateRemark',
    method: 'post',
    data
  })
};
// 会员加积分
export const addUserPoint= (data)=>{
  return axios.request({
    url: 'v1/member/changePoint',
    method: 'post',
    data
  })
};
// 会员资料编辑
export const editUser= (data)=>{
  return axios.request({
    url: 'v1/member/'+data.id,
    method: 'PUT',
    data
  })
};

 // 获取用户黑名单列表
export const getMemberBlackList = (params)=>{
  return axios.request({
    url: 'v1/member/black',
    method: 'get',
    params
  })
};
//会员撤销黑名单
export const delMemberBlack = (data)=>{
  return axios.request({
    url: 'v1/member/revokeBlack',
    method: 'post',
    data
  })
};

/**
  会员标签
*/

// 获取标签列表
export const getMemberTagList = (params)=>{
  return axios.request({
     url: 'v1/member-tag',
     method: 'get',
     params
   })
};
// 添加会员标签
export const createMemberTag= (data)=>{
  return axios.request({
    url: 'v1/member-tag',
    method: 'post',
    data
  })
};
   
// 删除会员标签
export const delMemberTag= (id)=>{
  return axios.request({
     url: 'v1/member-tag/'+id,
     method: 'DELETE',
   })
};

// 编辑会员标签
export const editMemberTag= (data)=>{
  return axios.request({
    url: 'v1/member-tag/'+data.id,
    method: 'PUT',
    data
  })
};

/**
 * 会员基础设置
 */

 // 获取用户成长设置配置
 export const getMemberExpConfig = (params)=>{
  return axios.request({
    url: 'v1/memberExpConfig',
    method: 'get',
    params
  })
};
 
// 设置用户成长配置
export const setMemberExpConfig = (data)=>{
  return axios.request({
    url: 'v1/memberExpConfig',
    method: 'post',
    data
  })
};

//微信卡包设置详情
export const getMemberWechat = ()=>{
  return axios.request({
    url: 'v1/memberWechat/detail',
    method: 'get'
  })
};

//微信卡包设置
export const setMemberWechat = (data)=>{
  return axios.request({
    url: 'v1/memberWechat/create',
    method: 'post',
    data
  })
};

//会员中心模板
export const getMemberCenter = ()=>{
  return axios.request({
    url: 'v1/member/center-template',
    method: 'get'
  })
};

//会员中心模板设置
export const setMemberCenter = (data)=>{
  return axios.request({
    url: 'v1/member/center-template',
    method: 'PUT',
    data
  })
};

// 设置用户会员卡
export const setMemberVip = (data)=>{
  return axios.request({
    url: 'v1/member-vip',
    method: 'post',
    data
  })
};
  // 删除用户会员卡
export const delMemberVip = (id)=>{
  return axios.request({
    url: 'v1/member-vip/'+id,
    method: 'DELETE'
  })
};
  
  // 编辑用户会员卡
export const editMemberVip = (id,data)=>{
  return axios.request({
    url: 'v1/member-vip/'+id,
    method: 'put',
    data
  })
};
// 获取用户会员卡列表
export const getMemberVip = (params)=>{
  return axios.request({
    url: 'v1/member-vip',
    method: 'get',
    params
  })
};
  // 获取用户会员卡详情
export const getMemberVipDetail = (id)=>{
  return axios.request({
    url: 'v1/member-vip/'+id,
    method: 'get'
  })
};
// 会员解绑
export const setMemberUnbind = (id)=>{
  return axios.request({
    url: 'v1/member/unbind/'+id,
    method: 'post'
  })
};
// 会员卡操作记录
export const getVipLog = (params)=>{
  return axios.request({
    url: 'v1/integral/vipLog',
    method: 'get',
    params
  })
};
// 会员派券
export const memberAddCoupon = (data)=>{
  return axios.request({
    url: 'v1/member/addCoupon',
    method: 'post',
    data
  })
};
// 会员卡券明细
export const getMemberCouponLog = (params)=>{
  return axios.request({
    url: 'v1/member/couponLog/'+params.member_id,
    method: 'get',
    params
  })
};


//会员还能送多少成长值
export const getMemberNeedExp = (params)=>{
  return axios.request({
    url: 'v1/member/needExp',
    method: 'get',
    params
  })
};

//添加成长值
export const postMemberAddExp = (data)=>{
  return axios.request({
    url: 'v1/member/addExp',
    method: 'post',
    data
  })
};

//新增字段
export const addCustomize = (data)=>{
  return axios.request({
    url: 'v1/collection/addCustomize',
    method: 'post',
    data
  })
};

//字段列表
export const customizes = (data)=>{
  return axios.request({
    url: 'v1/collection/customizes',
    method: 'get',
  })
};


//字段更新
export const editCustomize = (data)=>{
  return axios.request({
    url: 'v1/collection/editCustomize/'+data.id,
    method: 'post',
    data
  })
};

//获取配置
export const configShow = ()=>{
  return axios.request({
    url: 'v1/collection/configShow',
    method: 'get',
  })
};

//删除字段
export const delCustomizes = (id)=>{
  return axios.request({
    url: 'v1/collection/delCustomizes/'+id,
    method: 'delete',
  })
};

//资料收集配置更新
export const updateConfig = (data)=>{
  return axios.request({
    url: 'v1/collection/updateConfig',
    method: 'post',
    data
  })
};

//新会员概况
export const memberGeneral = (params)=>{
  return axios.request({
    url: 'v1/member/memberGeneral',
    method: 'get',
    params
  })
};

//会员中心登录地址
export const loginAddress = (params)=>{
  return axios.request({
    url: 'v1/member/loginAddress',
    method: 'get',
    params
  })
};
//祝福文案
export const memberWish = (params)=>{
  return axios.request({
    url: 'v1/member-vip/wish',
    method: 'get',
    params
  })
};

//祝福文案状态修改
export const editMemberWish = (id)=>{
  return axios.request({
    url: 'v1/member-vip/wish/'+ id,
    method: 'post',
   
  })
};

//云店消费
export const consumptionStatistics = (params)=>{
  return axios.request({
    url: 'v1/member/consumptionStatistics',
    method: 'get',
    params
  })
};

//添加会员标签
export const memberTag = (data)=>{
  return axios.request({
    url: 'v1/member-tag',
    method: 'post',
    data
  })
};

//会员标签列表
export const getMemberTag = (data)=>{
  return axios.request({
    url: 'v1/member-tag',
    method: 'get',
    data
  })
};

//会员标签详情
export const getMemberTagInfo = (id)=>{
  return axios.request({
    url: 'v1/member-tag/'+id,
    method: 'get'
  })
};

//会员标签修改
export const postMemberTagInfo = (data)=>{
  return axios.request({
    url: 'v1/member-tag/'+data.id,
    method: 'put',
    data
  })
};

//会员标签人数
export const tagMemberDetail = (params)=>{
  return axios.request({
    url: 'v1/member-tag/tagMemberDetail/'+params.id,
    method: 'get',
    params
  })
};

//会员打标签
export const postMemberTag = (data)=>{
  return axios.request({
    url: 'v1/member-tag/tag/'+data.id,
    method: 'post',
    data
  })
};

//扫码统计
export const getScanStatistics = (params)=>{
  return axios.request({
    url: 'v1/member/scanStatistics',
    method: 'get',
    params
  })
};


//商品一级分类
export const memberTagCat = ()=>{
  return axios.request({
    url: 'v1/member-tag/cat',
    method: 'get',
  })
};

//字段类型
export const collectionTypes = ()=>{
  return axios.request({
    url: 'v1/collection/types',
    method: 'get',
  })
};

//获取会员卡有效期设置
export const getPeriodOfValidity = ()=>{
  return axios.request({
    url: 'v1/member-vip/period_of_validity',
    method: 'get',
  })
};

//会员卡有效期设置
export const setPeriodOfValidity = (data)=>{
  return axios.request({
    url: 'v1/member-vip/period_of_validity',
    method: 'PUT',
    data
  })
};

// /v1/member_attach_info_config

//会员自定义信息-列表
export const member_attach_info_config = ()=>{
  return axios.request({
    url: 'v1/member_attach_info_config',
    method: 'get',
  })
};

//会员自定义信息-添加
export const createMemberAttachInfoConfig = (data)=>{
  return axios.request({
    url: 'v1/member_attach_info_config',
    method: 'post',
    data
  })
};

//会员自定义信息-修改
export const updateMemberAttachInfoConfig = (id,data)=>{
  return axios.request({
    url: 'v1/member_attach_info_config/'+id,
    method: 'PUT',
    data
  })
};//会员自定义信息-删除
export const delMemberAttachInfoConfig = (id)=>{
  return axios.request({
    url: 'v1/member_attach_info_config/'+id,
    method: 'DELETE'
  })
};

//会员附加信息-列表
export const member_attach_info = (params)=>{
  return axios.request({
    url: 'v1/member_attach_info',
    method: 'get',
    params
  })
};


//会员附加信息-添加
export const createMemberAttachInfo = (data)=>{
  return axios.request({
    url: 'v1/member_attach_info',
    method: 'post',
    data
  })
};


//会员附加信息-修改
export const updateMemberAttachInfo = (id,data)=>{
  return axios.request({
    url: 'v1/member_attach_info/'+id,
    method: 'PUT',
    data
  })
};
//会员附加信息-删除
export const delMemberAttachInfo = (id,data)=>{
  return axios.request({
    url: 'v1/member_attach_info/'+id,
    method: 'DELETE',
    data
  })
};